var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpAndRunning4Switzerland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "311px",
    height: "306px",
    viewBox: "0 0 311 306",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C949912A-E429-4A3F-ACCC-D732B49ED0EB@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M138,0 C142.418278,-8.11624501e-16 146,3.581722 146,8 L146,144 C146,148.418278 142.418278,152 138,152 L26,152 C21.581722,152 18,148.418278 18,144 L18.000905,86.9741828 C7.97191486,86.4546221 0,78.1582813 0,68 C0,57.8417187 7.97191486,49.5453779 18.000905,49.0258172 L18,8 C18,3.581722 21.581722,8.11624501e-16 26,0 L138,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.1%",
    y: "-3.9%",
    width: "108.2%",
    height: "107.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.549019608   0 0 0 0 0.729411765  0 0 0 0.422202797 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 64,
    height: 62,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-34.4%",
    y: "-32.3%",
    width: "168.8%",
    height: "171.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.343486631   0 0 0 0 0.287455037   0 0 0 0 0.923290308  0 0 0 0.239647072 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M292,0 C296.418278,-8.11624501e-16 300,3.581722 300,8 L300,47.625 L300,47.625 C289.50659,47.625 281,56.6278075 281,67.7333333 C281,78.8388592 289.50659,87.8416667 300,87.8416667 L300,119 C300,123.418278 296.418278,127 292,127 L11,127 C6.581722,127 3,123.418278 3,119 L3,8 C3,3.581722 6.581722,8.11624501e-16 11,0 L292,0 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.5%",
    y: "-8.3%",
    width: "107.1%",
    height: "116.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.549019608   0 0 0 0 0.729411765  0 0 0 0.351862981 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-8",
    x: 0,
    y: 0,
    width: 60,
    height: 58,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-36.7%",
    y: "-34.5%",
    width: "173.3%",
    height: "175.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.343486631   0 0 0 0 0.287455037   0 0 0 0 0.923290308  0 0 0 0.239647072 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "path-11",
    x: 0,
    y: 0,
    width: 60,
    height: 58,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-36.7%",
    y: "-34.5%",
    width: "173.3%",
    height: "175.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.343486631   0 0 0 0 0.287455037   0 0 0 0 0.923290308  0 0 0 0.239647072 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "path-14",
    x: 0,
    y: 0,
    width: 60,
    height: 58,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-36.7%",
    y: "-34.5%",
    width: "173.3%",
    height: "175.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.343486631   0 0 0 0 0.287455037   0 0 0 0 0.923290308  0 0 0 0.239647072 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "path-17",
    x: 0,
    y: 0,
    width: 60,
    height: 58,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-36.7%",
    y: "-34.5%",
    width: "173.3%",
    height: "175.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-19"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.343486631   0 0 0 0 0.287455037   0 0 0 0 0.923290308  0 0 0 0.239647072 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Up-and-Running---Switzerland",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pricing----\\u2026und-was-ist,--wenn-ich-es-nicht-schaffe?",
    transform: "translate(-768.000000, -242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(352.000000, 177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog-Box-/-Base-/-Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration/Up-and-Running/4--SWI",
    transform: "translate(420.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(73.000000, 143.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C6E5F7",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Verl\\xE4ngerung-Projekt",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: 0.24
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    y: 23,
    fill: "#008CBA"
  }, "VERL\xC4NGERUNG"), /*#__PURE__*/React.createElement("tspan", {
    x: 126.731562,
    y: 23,
    letterSpacing: -0.4,
    fill: "#47CAF5"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 129.319844,
    y: 23,
    letterSpacing: -0.4,
    fill: "#47CAF5"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    y: 37,
    fontFamily: "Roboto-Regular, Roboto",
    fontWeight: "normal",
    letterSpacing: -0.4,
    fill: "#47CAF5"
  }, "Projektlaufzeit")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F1675E",
    opacity: 0.083984375,
    cx: 82,
    cy: 81,
    r: 49
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F1675E",
    opacity: 0.083984375,
    cx: 82,
    cy: 81,
    r: 45
  }), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/_Calendar",
    transform: "translate(49.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#008CBA",
    mask: "url(#mask-4)",
    x: 0,
    y: 0,
    width: 64,
    height: 19.375
  })), /*#__PURE__*/React.createElement("text", {
    id: "Month-1",
    fontFamily: "Capitolium2-Bold, Capitolium2",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.34715152,
    y: 13.65625
  }, "+1 Monat")), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Plus",
    transform: "translate(15.515152, 21.312500)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#008CBA",
    fillRule: "evenodd",
    points: "26.8686869 18.3658854 18.3838384 18.3658854 18.3838384 26.8424479 15.5555556 26.8424479 15.5555556 18.3658854 7.07070707 18.3658854 7.07070707 15.5403646 15.5555556 15.5403646 15.5555556 7.06380208 18.3838384 7.06380208 18.3838384 15.5403646 26.8686869 15.5403646"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 33.9393939 0 33.9393939 33.90625 0 33.90625"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C6E5F7",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/_Calendar",
    transform: "translate(10.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#008CBA",
    mask: "url(#mask-9)",
    x: 0,
    y: 0,
    width: 60,
    height: 18.125
  })), /*#__PURE__*/React.createElement("text", {
    id: "Month-1",
    fontFamily: "Capitolium2-Bold, Capitolium2",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8.67745455,
    y: 12.96875
  }, "Monat 1")), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Check-Mark",
    transform: "translate(14.545455, 19.937500)",
    fill: "#006197",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "11.560998 21.3549095 5.90372887 15.542593 3.97727273 17.5079086 11.560998 25.2994792 27.8409091 8.57338856 25.9280195 6.60807292"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/_Calendar",
    transform: "translate(77.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#008CBA",
    mask: "url(#mask-12)",
    x: 0,
    y: 0,
    width: 60,
    height: 18.125
  })), /*#__PURE__*/React.createElement("text", {
    id: "Month-1",
    fontFamily: "Capitolium2-Bold, Capitolium2",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8.10145455,
    y: 12.96875
  }, "Monat 2")), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Check-Mark",
    transform: "translate(14.545455, 19.937500)",
    fill: "#006197",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "11.560998 21.3549095 5.90372887 15.542593 3.97727273 17.5079086 11.560998 25.2994792 27.8409091 8.57338856 25.9280195 6.60807292"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/_Calendar",
    transform: "translate(214.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#009C63",
    mask: "url(#mask-15)",
    x: 0,
    y: 0,
    width: 60,
    height: 18.125
  })), /*#__PURE__*/React.createElement("text", {
    id: "Month-1",
    fontFamily: "Capitolium2-Bold, Capitolium2",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.68145455,
    y: 12.96875
  }, "Monat 4")), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Check-Mark",
    transform: "translate(14.545455, 19.937500)",
    fill: "#31AF81",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "11.560998 21.3549095 5.90372887 15.542593 3.97727273 17.5079086 11.560998 25.2994792 27.8409091 8.57338856 25.9280195 6.60807292"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/_Calendar",
    transform: "translate(146.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-19)",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#008CBA",
    mask: "url(#mask-18)",
    x: 0,
    y: 0,
    width: 60,
    height: 18.125
  })), /*#__PURE__*/React.createElement("text", {
    id: "Month-1",
    fontFamily: "Capitolium2-Bold, Capitolium2",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8.29345455,
    y: 12.96875
  }, "Monat 3")), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Check-Mark",
    transform: "translate(14.545455, 19.937500)",
    fill: "#006197",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "11.560998 21.3549095 5.90372887 15.542593 3.97727273 17.5079086 11.560998 25.2994792 27.8409091 8.57338856 25.9280195 6.60807292"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Normal-Projektlaufze",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: 0.24
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10.1848828,
    y: 24,
    fill: "#008CBA"
  }, "NORMAL"), /*#__PURE__*/React.createElement("tspan", {
    x: 60.8436328,
    y: 24,
    letterSpacing: -0.4,
    fill: "#47CAF5"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 66.0201953,
    y: 24,
    fontFamily: "Roboto-Regular, Roboto",
    fontWeight: "normal",
    letterSpacing: -0.4,
    fill: "#47CAF5"
  }, "Projektlaufzeit")), /*#__PURE__*/React.createElement("text", {
    id: "3.900-CHF",
    opacity: 0.715866815,
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 20,
    fontWeight: "bold",
    fill: "#659FC0"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 102,
    y: 289
  }, "3.900 CHF "))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpAndRunning4Switzerland);
export default __webpack_public_path__ + "static/media/up_and_running_4_switzerland.1f3ac5b1a082c2bb0d2a3e622a4b98fb.svg";
export { ForwardRef as ReactComponent };